import { versionInfo } from '../version/version';

// configuration for local server
export const environment = {
  production: true,
  graphql_http: 'https://resourcepanorama-api.greenpowermonitor.com/graphql',
  sso_url: 'https://ssok.greenpowermonitor.com/auth',
  image_server: 'https://image-server.energy-log.com',
  shared_server: 'https://shared-data.energy-log.com',
  file_manager: 'https://file-manager-api.greenpowermonitor.com',
  file_server: 'rp-documents',
  auth_enabled: true,
  keycloak_init_options: {
    onLoad: 'login-required',
    checkLoginIframe: false,
  },

  versionInfo: versionInfo,

  integration: false,
};
